/*jshint ignore:start */

import {
  getUrlVars,
  getCookie,
  setCookie,
  subSourcePopulation,
  attributeValidation,
  captchaValidation,
  isScriptAdded,
  sentEmail,
  sentEmailWithFetch,
  sendLeadToRep,
  deviceValidate,
  getBrowser,
  apolloCallAPI,

  // getKickboxResponse,
  // getMelissaResponse,
  // checkGDPR
} from '@/public/functions';
import { impactLeadPixel, initImpactCookie } from '@/TrackingPixel/Impact';
import { smbTracking } from '@/TrackingPixel/SMB';
import { chiliPiper } from '@/TrackingPixel/ChiliPiper';
import { apolloScheduleAMeeting } from '@/TrackingPixel/Apollo';
import { trackNoCookieData } from '@/public/noCookieTracking';

//if sub source is not existing or value is empty, pass program name as the sub source:
const uri = window.location.href;
const currentPath = window.location.pathname;

// checkGDPR();
// initial sub source, make sure sub source has value. 


const initSubSource = () => {
  const forms = document.getElementsByClassName('needs-validation');
  let programName, i = 0;

  for (; i < forms.length; i++) {
    let j = 0;
    const myForm = forms[i];
    const inputLabelList = myForm.querySelectorAll('input:not([type="hidden"]):not(.d-none), select');
    const programNameInput = myForm.querySelector('input[name="programName"]');


    if (programNameInput !== null) {
      programName = programNameInput.value;

      subSourcePopulation(myForm, 'data-sub-source', programName);

      for (; j < inputLabelList.length; j++) {
        let myInput = inputLabelList[j];
        let getDataAsset, getSubsource, getAriaLabel, getDataEvent, updatedAriaLabel, getLabel, getLabelVal, myInputID;
        getDataAsset = myForm.getAttribute('data-asset');
        getSubsource = myForm.getAttribute('data-sub-source');
        getAriaLabel = myInput.getAttribute('aria-label');
        getDataEvent = myForm.getAttribute('data-event');
        myInputID = myInput.getAttribute('id');
        // getLabel = myInput.previousElementSibling;
        if (myInput.previousElementSibling !== null && myInput.previousElementSibling.tagName === 'LABEL') {
          getLabel = myInput.previousElementSibling;
        } else {
          getLabel = myInput.nextElementSibling;
        }

        //if it is a radio tag, the label tag will be under the input tag, so need to change to:
        if (myInput.getAttribute('type') === 'radio') {
          getLabel = myInput.nextElementSibling;
        }

        if (myInputID !== null) {
          if (myInput !== null) {
            myInput.setAttribute('id', myInputID + '-form' + i);
            if ($(myInput).hasClass('form-check-input')) {
              $(myInput).parent('label').attr('for', myInputID + '-form' + i);
            }
          }

          if (getLabel !== null) {
            getLabel.setAttribute('for', myInputID + '-form' + i);
            if (getLabel.getElementsByTagName('label') !== undefined) {
              getLabelVal = getLabel.textContent;
              getLabelVal = getLabelVal.replace(/(\r\n|\n|\r)/gm, "").replace(/ +(?= )/g, '');
            }
          }


        }



        updatedAriaLabel = getLabelVal + ' for' + attributeValidation(getDataEvent) + attributeValidation(getSubsource) + attributeValidation(getDataAsset);

        myInput.setAttribute('aria-label', updatedAriaLabel.trim());


      }


    }


  }

}

const loadChiliPiperScript = () => {
  $('form').each(function () {
    let cpScript = 'https://js.chilipiper.com/marketing.js';
    let checkStatus = $(this).attr('data-add-cp');
    if (checkStatus !== undefined && checkStatus.length > 0) {
      if (checkStatus.toUpperCase().includes('Y') && !isScriptAdded(cpScript)) {
        console.log('load CP');
        const script = document.createElement('script');
        script.async = true;
        script.src = cpScript;

        // Append to the `head` element
        document.head.appendChild(script);
      }
    }
  })
}

const loadApolloScript = () => {
  $('form').each(function () {
    let apolloScript = 'https://assets.apollo.io/js/meetings/meetings-widget.js';
    let checkStatus = $(this).attr('data-add-apollo');
    if (checkStatus !== undefined && checkStatus.length > 0) {
      if (checkStatus.toUpperCase().includes('MEETING') && !isScriptAdded(apolloScript)) {
        console.log('load Apollo');
        const script = document.createElement('script');
        script.defer = true;
        script.src = apolloScript;
        script.onload = function () {
          window.ApolloMeetings.initWidget({
            appId: "6543e8e21c1d9d00a376fae9",
            schedulingLink: "0k9-w7f-pfo"
          });
        };
        // Append to the `head` element
        document.head.appendChild(script);
      }
    }
  })

}

loadApolloScript();

loadChiliPiperScript();
initSubSource();

const openNewTab = (asset) => {
  // console.log('open new tab');
  let redirectWindow = window.open(asset, '_blank');
  redirectWindow.location;
  // location.reload();
}

//initial impact cookie for biz impact pages:
if (uri.includes('/biz/impact/')) {
  // console.log('biz impact page')
  initImpactCookie();

}
const addJCapthaList = [
  '/business-voip/small-business-phone-offers/',
  //BELOW URL IS FOR TESTING
  // '/'

]

const addGcaptchatList = [
  '/g-recaptcha-test/',
  '/business-voip/affordable-small-business-phone/'

];

if (addGcaptchatList.includes(currentPath) && getUrlVars()['xutm_medium'] !== undefined && getUrlVars()['xutm_medium'].indexOf('DISPLAY') > 0) {

  console.log('add google captchat!');
  // var verifyCallback = function (response) {
  //   console.log('google recaptcha is validated');
  // };
  // var onloadCallback = function () {
  //   grecaptcha.render('g-recaptchat', {
  //     'sitekey': '6LfXnBQUAAAAAFs3k3Kdjazg67kQBPnuDx-r_39K',
  //     'callback': verifyCallback,
  //     'theme': 'light'
  //   });
  // };
}


const isJcaptchaPage = addJCapthaList.includes(currentPath);
let myCaptcha;

if (isJcaptchaPage) {
  //need to wait when DOM is loaded:
  document.addEventListener('DOMContentLoaded', (event) => {
    // console.log('validate captcha');
    //in order to generate canvas for multiple form on the same page, need to give a different class for the canvas element: 
    let jCaptchaEls = document.querySelectorAll('.jCaptcha'), i;
    for (i = 0; i < jCaptchaEls.length; i++) {
      let myNewID = 'jCaptcha' + '-' + i;
      jCaptchaEls[i].id = myNewID;
      myCaptcha = captchaValidation(myNewID);
    }
  })

}

//need to wait when DOM is loaded:



// if (window.attachEvent) {

//   window.attachEvent('onload', trackNoCookieData());
// }
// else if (window.addEventListener) {

//   window.addEventListener('load', trackNoCookieData(), false);
// }
// else {

//   document.addEventListener('load', trackNoCookieData(), false);
// }


const submitFormData = () => {
  window.addEventListener('load', function () {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function (form) {

      form.addEventListener('submit', function (event) {

        event.preventDefault();

        // trackNoCookieData(); // check cookie functionality status.
        if (isJcaptchaPage && !$('.jCaptcha', form).hasClass('success')) {
          myCaptcha.validate(event);
        }

        let errorWarning = form.getElementsByClassName('errorWarning');
        let checkCookieStatus = trackNoCookieData()['cookieStatus'];
        let isRobot = false;
        let jCaptchaStatus = false;
        let imagePuzzleCaptcha = false;
        if ($('.robot-validation', form).length) {
          let honeypot = $('.robot-validation', form);
          let valAttr = honeypot.attr('value');

          if (typeof valAttr !== 'undefined') {
            if (valAttr.length > 0) {
              isRobot = true;
            }
          }
          if (honeypot.val().length > 0) {
            // console.log('this is robot');
            isRobot = true;
          }
        }
        if (isJcaptchaPage) {
          if ($('.jCaptcha', form).hasClass('error')) {
            jCaptchaStatus = true
          }
        }


        if ($('#data-validation', form).length !== undefined) {
          if ($('.image-puzzle-captcha', form).attr('data-validation') === 'invalid') {
            console.log('puzzle invalid');
            imagePuzzleCaptcha = true;
          }
        }



        let currentForm = $(this);
        if (isRobot === true) {
          // console.log('this is robot');
          event.preventDefault();
          event.stopPropagation();
        }

        else if (jCaptchaStatus === true || imagePuzzleCaptcha == true) {
          event.preventDefault();
          event.stopPropagation();
        }

        else if (form.checkValidity() === false) {
          // console.log('form invalidated');
          event.preventDefault();
          event.stopPropagation();
          // show error warning for mobile device:
          if (errorWarning.length) {
            errorWarning[0].classList.remove('d-none');
            $('.form-control', form).on(
              'keyup change', function name(params) {
                let invalidInput = $('.form-control:invalid', form).length;
                if (invalidInput === 0) {
                  errorWarning[0].classList.add('d-none');
                }
              }
            )
          }


        } else {
          if (errorWarning.length) {
            errorWarning[0].classList.add('d-none');
          }

          let userData = {};
          $.each($('*[class!="skip-passing-data"]', this).serializeArray(), function (_, kv) {

            if (userData.hasOwnProperty(kv.name)) {
              userData[kv.name] = $.makeArray(userData[kv.name]);
              userData[kv.name].push(kv.value);

            }


            else {
              userData[kv.name] = kv.value;
            }



          });





          console.log('userData', userData);


          const subSource = currentForm.attr('data-sub-source');

          let hiddenData = {
            'utm_campaign__c': getCookie('XYZutm_campaign'),
            'utm_source__c': getCookie('XYZutm_source'),
            'utm_medium__c': getCookie('XYZutm_medium'),
            'utm_term__c': getCookie('XYZutm_term'),
            'om_phone__c': getCookie('XYZom_phone'),
            'referrer_url__c': getCookie('XYZreferrer'),
            'page_url__c': currentPath,
            'gclid__c': getCookie('XYZgclid'),
            'utm_keyword__c': getCookie('XYZ_keyword'),
            'offer_code__c': getCookie('XYZoffer'),
            'Browser_Form_Submit__c': getBrowser().replace(/\s/g, "-").substring(0, 50),
            'Device_Form_Submit__c': deviceValidate() ? 'Mobile' : 'Desktop',
            'Lead_Sub_Source__c': subSource,
            'LeadSource': getCookie('XYZutm_source'),
            'Form_Domain__c': window.location.hostname,
            'Cookie_Date_2__c': getCookie('XYZ_cDate'),
            'Affiliate_Sub_ID__c': getCookie('impact_sharedID'),
            'cookieStatus': checkCookieStatus
          }


          //if cookie functionality is turned off, reset these values:
          if (checkCookieStatus === 'False') {
            hiddenData['LeadSource'] = trackNoCookieData()['temp_utm_source'];
            hiddenData['utm_source__c'] = trackNoCookieData()['temp_utm_source'];
            hiddenData['utm_campaign__c'] = trackNoCookieData()['temp_utm_campaign'];
            hiddenData['utm_medium__c'] = trackNoCookieData()['temp_utm_medium'];
            hiddenData['referrer_url__c'] = trackNoCookieData()['temp_referrer_url'];
          }



          if (uri.includes("airdial")) {
            hiddenData['Deal_Type__c'] = 'AirDial';

            $('input[name="lead_sub_source"]', currentForm).val(subSource);
            $('input[name="utm_source"]', currentForm).val(hiddenData['utm_source__c']);
            $('input[name="utm_medium"]', currentForm).val(hiddenData['utm_medium__c']);
            $('input[name="utm_campaign"]', currentForm).val(hiddenData['utm_campaign__c']);


          }
          if (uri.includes("schedule-a-meeting-chat")) {
            hiddenData['Quick_Notes__c'] = 'Chat is missed / offline';
          }

          if (uri.includes("/biz/impact/best-office-phone-which-voip/") || uri.includes("/biz/impact/top-10-checklist/")) {
            console.log('update ppl');
            hiddenData['PPL_Lead__c'] = 'true';
          }

          //for impact tracking:
          let impactData = {
            'Order_ID__c': getCookie('impact_orderID'),
            'Media_Partner_Id__c': getCookie('impact_partnerID'),
            'Customer_ID__c': getCookie('impact_customerID'),
            'Click_ID__c': getCookie('impact_clickID'),
            'Affiliate_Click_Id__c': getCookie('XYZ_aff_sid')
          }

          if (uri.includes('/biz/impact/')) {
            hiddenData = $.extend({}, hiddenData, impactData);
          }

          console.log('hiddenData: ', hiddenData);
          // console.log('userData: ', userData);
          // console.log('hiddenData: ', hiddenData);





          $('button', currentForm).attr('disabled', true);



          //// check google reCaptcha before sending data to sever:
          let newTab = false;
          let asset = '';
          //without google recaptcha


          $('button', currentForm).attr('disabled', false);

          let popupWrapper = currentForm.closest('.mfp-content');
          if (popupWrapper.length === 0) {
            popupWrapper = currentForm.closest('.js-new-marketo');
          }
          let formWrapper = popupWrapper.find('.form__wrapper');
          let thankYouInfo = popupWrapper.find('.thank-you__wrap');
          // console.log(thankYouInfo.length);


          if (formWrapper.length) {
            formWrapper.addClass('d-none');
            thankYouInfo.removeClass('d-none display-none');

          }

          //email Verification and add Kickbox reasponse to the userData
          //if Kickbox' response is delay over 5 seconds will skip the verification: 
          // getKickboxResponse('POST', { 'email': userData['Email'] }, '/wp-content/plugins/wp-ooma-mkto-api/server-side/kickbox/src/index.php', 5000, function (userDataWithKickbox) {
          //   userData = $.extend({}, userData, userDataWithKickbox);
          // });

          // console.log('new user data:', userData);
          let formData = $.extend({}, userData, hiddenData);
          sendData(formData, currentForm, userData);
          if (formWrapper.length) {
            chiliPiper(uri, currentForm, formData);
            apolloScheduleAMeeting(currentForm, formData);
          }

          // download whitepaper form:
          if ($('button', currentForm).hasClass('add-apollo-contact')) {
            // console.log('formData 02: ', formData);
            apolloCallAPI('POST', formData, '/wp-content/plugins/wp-ooma-mkto-api/server-side/apollo/create-update-contact.php');

          }
          //phone number validation:
          // getKickboxResponse('POST', { 'email': userData['Email'] }, '/wp-content/plugins/wp-ooma-mkto-api/server-side/melissage/index.php', 5000, function (userDataWithKickbox) {
          //   userData = $.extend({}, userData, userDataWithKickbox);
          // });





          //open a new tab for asset or post data by ajax:
          asset = currentForm.attr('data-asset');
          const postType = currentForm.attr('data-post-method');
          // const path = '//www.ooma.com/uploads/';
          if (asset.length) {
            console.log('postType:' + postType);
            if (postType == 'post') {

              $.ajax({
                type: 'POST',
                url: asset,
                success: function (data) {
                  // let responseData = JSON.parse(data);
                  console.log('Opened a new tap');
                },
                error: function (xhr, status, error) {
                  console.log(status);
                  console.log(error);
                }
              });
            }
            else {
              //open a new tab out of the success function because it does not support Safari browser here.
              newTab = true;

            }






          }


          //if open a new tab:
          if (newTab) {
            openNewTab(asset);
          }

        }
        form.classList.add('was-validated');

      }, false);
    });
  }, false);

  const sendData = (data, currentForm, userData) => {

    let _thisdata = data;
    // //impact tracking:
    let pixelID;
    let email = _thisdata['Email'];




    if (uri.includes('/home-phone/impact/') || uri.includes('/home-security/impact/')) {
      pixelID = 24185;
      impactLeadPixel(pixelID, email);
    }
    if (uri.includes('/biz/impact/')) {
      pixelID = 15797;
      impactLeadPixel(pixelID, email);
    }

    if (uri.includes('-dwa') || uri.includes('-ifg')) {
      smbTracking('smart00', 'AW-926850839/ineSCNnX3JEBEJe--rkD');
    }






    //============Send Lead to Reps directly===============//
    let isSendEmail = $(currentForm).attr('data-send-email');
    if (isSendEmail !== undefined && isSendEmail.length > 0) {
      sendLeadToRep(isSendEmail, userData);
    }
    //=========End Send Lead to specific email=================//


    //=====Disable Mkto API: Stop sending CURRENT lead to marketo if the submit button has class 'schedule-a-consultation' or 'mkto-disable'=====//

    // if ($('button', currentForm).hasClass('schedule-a-consultation') ||
    //   $('button', currentForm).hasClass('mkto-disable') ||
    //   $('button', currentForm).hasClass('add-apollo-meeting') ||
    //   $('button', currentForm).hasClass('add-apollo-contact')) {
    //   console.log('Disable mkto API');
    //   return;
    // }

    if ($('button', currentForm).hasClass('schedule-a-consultation') ||
      $('button', currentForm).hasClass('mkto-disable')) {
      console.log('Disable mkto API');
      return;
    }





    //===================End Disable Mkto API====================================//

    //send data to Apollo:


    // if ($('button', currentForm).hasClass('add-apollo-contact')) {
    //   console.log('_thisdata: ', _thisdata);
    //   let apolloData = {
    //     'first_name': _thisdata['FirstName'],
    //     'last_name': _thisdata['LastName'],
    //     'email': _thisdata['Email'],
    //     'organization_name': _thisdata['Company'],
    //     'industry': _thisdata['Industry'],

    //   };
    //   console.log('send data to apollo via API:', apolloData);
    //   // apolloCallAPI('POST', apolloData, '/wp-content/plugins/wp-ooma-mkto-api/server-side/apollo/create-update-contact.php');

    // }







    $.ajax({
      type: 'POST',
      url: '/wp-content/plugins/wp-ooma-mkto-api/server-side/mkto-api.php',
      // url: '/mkto-form-test/',
      // contentType: "application/json; charset=utf-8",
      // dataType: 'json',
      data: data,
      success: function (data) {
        // console.log('success:', typeof data);

        //send data to Munchkin:
        Munchkin.init('161-LIC-035');
        Munchkin.munchkinFunction('associateLead', {
          Email: email,
          ProgramName: _thisdata['programName'],
          Lead_Sub_Source__c: _thisdata['Lead_Sub_Source__c']
        });
        console.log('sent data to Munchkin');

        let responseData = JSON.parse(data);

        console.log('responseData : ', responseData);


        //---Test for when the response from ajex is not success:---/
        // let responseStatus = {
        //   'status': `Lead is not sent, status code: 0`
        // }
        // let sendData = $.extend({}, _thisdata, responseStatus)
        // sentEmail('POST', sendData, '/wp-content/plugins/wp-ooma-mkto-api/server-side/lead-detection/notification-from-mkto.php');
        //----------End test------------//


        if (!responseData['success']) {
          let errorMessage = {
            'requestId': responseData['requestId'],
            'errorCode': responseData['errors'][0]['code'],
            'errorStatus': responseData['errors'][0]['message']
          }

          let sendData = $.extend({}, _thisdata, errorMessage);
          console.log('ajax sendData: ', sendData);
          sentEmail('POST', sendData, '/wp-content/plugins/wp-ooma-mkto-api/server-side/lead-detection/notification-from-mkto.php');
        }

        //clean values:
        $('input:not([type="hidden"])', currentForm).each(function () {
          $(this).val('');
        });
        $('input[type="checkbox"]', currentForm).each(function () {
          $(this).prop('checked', false);
        });
        $('option:selected', currentForm).each(function () {
          $(this).prop("selected", false);
        });
        $('option:disabled', currentForm).each(function () {
          $(this).prop("selected", true);
        })
        currentForm.removeClass('needs-validation was-validated').addClass('novalidate');
        //fire pixels:


        // // //impact tracking:
        // let pixelID;
        // if (uri.includes('/home-phone/impact/') || uri.includes('/home-security/impact/')) {
        //   pixelID = 24185;
        //   impactLeadPixel(pixelID, email);
        // }
        // if (uri.includes('/biz/impact/')) {
        //   pixelID = 15797;
        //   impactLeadPixel(pixelID, email);
        // }

        // if (uri.includes('-dwa') || uri.includes('-ifg')) {
        //   smbTracking('smart00', 'AW-926850839/ineSCNnX3JEBEJe--rkD');
        // }



        //add a status flag:
        setCookie('MktoFrom', 'Submitted');

      },
      error: function (xhr, status, error) {
        let responseStatus = {
          'status': `Lead is not sent, status code: ${xhr.status}`
        }
        let sendData = $.extend({}, _thisdata, responseStatus)
        sentEmail('POST', sendData, '/wp-content/plugins/wp-ooma-mkto-api/server-side/lead-detection/notification-from-mkto.php');
        console.log(error);
        console.log(xhr.status);
      }
    });
  }


};






submitFormData();





